import PropTypes from 'prop-types';
import { useState, useRef } from 'react';

import { tariffShape } from 'helpers/shared_types';

import { ReactComponent as CloseStrokeSVG } from 'icons/close-stroke.svg';

import Input from 'components/input/input';
import { useOutsideClick } from 'helpers/clickOutside';
import Button from 'components/button';

const MIN_CHARGE = 0.5;

const TCChargeModal = ({
  type,
  title,
  content,
  tariff,
  onClose,
  onClickOutside,
  onCharge,
}) => {
  const [charge, setCharge] = useState('');
  const [valid, setValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const [validationText, setValidationText] = useState('');

  const ref = useRef(null);
  useOutsideClick(ref, onClickOutside);

  const handleCharge = () => {
    if (
      charge === '0' ||
      (charge >= MIN_CHARGE && charge <= parseFloat(tariff.amount))
    ) {
      setLoading(true);
      onCharge(charge);
    } else {
      if (charge > 0 && charge < MIN_CHARGE) {
        setValidationText('Amount should be more or equal to €0.5!');
      } else {
        setValidationText(
          `Amount should be less or equal to the tariff: €${tariff.amount}`,
        );
      }

      setValid(false);
    }
  };

  return (
    <div
      className="fullscreen-modal-container"
      style={{ visibility: 'visible' }}
    >
      <div className="fullscreen-modal-background"></div>
      <div
        className="fullscreen-modal fullscreen-modal-action fullscreen-modal-wide"
        ref={ref}
      >
        <section className="modal-content">
          <header className="modal-header">
            <h1>{title}</h1>
          </header>
          <span onClick={() => onClose()} className="pointer close">
            <CloseStrokeSVG />
          </span>

          <div className="modal-body">
            <p
              className="mb6"
              dangerouslySetInnerHTML={{ __html: content }}
            ></p>

            <Input
              name="charge"
              label="Charge"
              value={charge}
              type="number"
              placeholder="0.00"
              min="0"
              valid={valid}
              validationText={validationText}
              withCurrency={true}
              onChange={(e) => setCharge(e.target.value)}
              onKeyDown={(e) => {
                [69, 107, 109, 187, 189].includes(e.keyCode) &&
                  e.preventDefault();
              }}
              onPaste={(e) => e.preventDefault()}
            />
          </div>

          <div className="modal-footer flex justify-end">
            <Button label="Cancel" color="white" onClick={onClose} />
            <Button
              label="Charge"
              color="green"
              loading={loading}
              onClick={handleCharge}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

TCChargeModal.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  tariff: tariffShape,
  onClose: PropTypes.func.isRequired,
  onClickOutside: PropTypes.func.isRequired,
  onCharge: PropTypes.func.isRequired,
};

export default TCChargeModal;
